import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEyedropper: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="eyedropper, color-picker, pipette, suction-tube, labor"><path d="M11 9L5.5 14.5L4.5 17.5L4 18C3.44772 18.5523 3.44772 19.4477 4 20C4.55228 20.5523 5.44772 20.5523 6 20L6.5 19.5L9.5 18.5L15 13" stroke="currentColor" strokeWidth="1.5"/><path d="M16.5357 13.75L10.25 7.46454L11.8214 5.89311H13.9167L15.6148 4.43744C16.7256 3.48527 18.3822 3.54886 19.4167 4.58337C20.4512 5.61785 20.5148 7.27439 19.5627 8.38517L18.1071 10.0833V12.1786L16.5357 13.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconEyedropper;
